import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { EditorialMap } from 'client/tracking/maps/editorial';
import { TrackingConstant } from 'client/tracking/constant';
import { IncentivesWizardMap } from 'client/tracking/maps/incentives-wizard';

const map = {
  get_offers: TrackingEvent.actionCompleted(TrackingConstant.ACTION_TOOL_SELECT, TrackingConstant.GET_OFFERS),
  im_tool_select: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.ACTION_TOOL_SELECT
  ),
  incentive_info_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.VIEW_MORE
  ),
  incentive_info_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.VIEW_LESS
  ),
  display_incentive_details: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    'display_incentive_details'
  ),
  submit_incentives_tool_survey: TrackingEvent.actionCompleted(
    TrackingConstant.ENGAGE_SURVEY,
    'submit_incentives_tool_survey'
  ),
  incentives_tool_survey_yes_comment: TrackingEvent.actionCompleted(
    TrackingConstant.ENGAGE_SURVEY,
    'incentives_tool_survey_yes_comment'
  ),
  incentives_tool_survey_no_comment: TrackingEvent.actionCompleted(
    TrackingConstant.ENGAGE_SURVEY,
    'incentives_tool_survey_no_comment'
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...EditorialMap,
  ...IncentivesWizardMap,
  ...map,
};
